export default __webpack_public_path__ + "static/media/Power_Substation.b080ee04.png";